import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const FooterDesktop = styled.footer`
  font-family: 'Pretendard Variable', Pretendard, -apple-system,
    BlinkMacSystemFont, 'Apple SD Gothic Neo', Roboto, 'Noto Sans KR',
    'Segoe UI', 'Malgun Gothic', 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol', sans-serif;

  background-color: #f9f9f9;
  border-top: 1px solid #eee;
  margin-top: 120px;
  padding: 40px 20px;

  .inner-footer {
    max-width: var(--pc-width);
    margin: 0 auto;
    ${mixin.flex({ justify: 'flex-start' })};

    .right,
    .left {
      ${mixin.flex({
        direction: 'column',
        justify: 'flex-start',
        align: 'flex-start',
      })};
    }

    .left {
      min-width: 595px;
    }
  }

  .title {
    font-size: 16px;
    font-weight: 500;
    line-height: 130%;
    color: #000;
  }

  .box-nav {
    .nav-terms,
    .nav-util {
      ${mixin.flex({ justify: 'flex-start', wrap: 'wrap' })}
      column-gap: 16px;

      a {
        font-size: 16px;
        font-weight: 500;
        line-height: 120%;
        color: #000;
      }

      strong {
        font-weight: 600;
      }
    }

    .nav-terms {
      margin-top: 12px;
    }
  }

  .help {
    margin-top: 60px;

    .title {
      padding-bottom: 3px;

      a {
        ${mixin.flex({ justify: 'flex-start' })};
        font-size: inherit;
        font-weight: inherit;
        line-height: inherit;
        color: inherit;
      }

      svg {
        width: 15px;
        height: 15px;
        margin-left: 2px;
        margin-bottom: 3px;
      }
    }

    .column {
      ${mixin.flex({
        direction: 'column',
        justify: 'flex-start',
        align: 'flex-start',
      })};

      .tel {
        display: inline-block;
        height: 34px;
        font-size: 28px;
        font-weight: 600;
        line-height: 120%;
        color: #000;
      }

      .time {
        display: inline-block;
        margin-left: 4px;
        font-size: 16px;
        color: #999;
        font-weight: 500;
      }

      .insta {
        width: 20px;
        height: 20px;
        margin-top: 10px;
      }
    }
  }

  .aside,
  .address {
    .title {
      padding-bottom: 7px;
    }

    .list {
      color: #777;
      font-size: 13px;
      line-height: 130%;
      ${mixin.flex({
        direction: 'column',
        wrap: 'wrap',
        justify: 'flex-start',
        align: 'flex-start',
      })};
      gap: 5px 16px;

      .micro-btn {
        color: #000;
        text-decoration: underline;
        margin-left: 4px;
      }

      .tel {
        color: #777;
      }
    }
  }

  .address .list {
    ${mixin.flex({
      wrap: 'wrap',
      justify: 'flex-start',
      align: 'flex-start',
    })};

    .offline_store {
      flex-basis: 100%;
    }
  }

  .aside {
    margin-top: 24px;
  }

  .desc {
    width: var(--pc-width);
    font-size: 13px;
    line-height: 130%;
    color: #777;
    margin: 24px auto 0;
    padding-top: 24px;
    border-top: 1px solid #eee;
  }
`;
